module.exports = __webpack_public_path__ + "img/MihmedTahir-RozhekDagareynawa.71a60056.jpg";